import cn from 'classnames'
import { useState } from 'react'
import { useSwiperSlide } from 'swiper/react'

import { Text } from '@ds'
import { LockIcon, MarkIcon, Star } from '@shared'

import styles from './StarSliderItem.module.scss'

type Props = {
  title: string
  src: string
  isAvailable: boolean
  isEquipped: boolean
}

export const StarSliderItem = ({
  title,
  src,
  isAvailable,
  isEquipped,
}: Props) => {
  const [count, setCount] = useState(0)
  const swierSlide = useSwiperSlide()
  const { isActive, isVisible } = swierSlide

  const renderIcon = () => {
    if (isEquipped) {
      return <MarkIcon className={styles.icon} />
    }

    if (!isAvailable) {
      return <LockIcon className={styles.icon} />
    }

    return null
  }

  return (
    <div>
      <Star
        key={count}
        size="xxl"
        src={src}
        shouldAnimate={isVisible}
        isVisible={isVisible}
        isActive={isActive}
        onClick={() => {
          setTimeout(() => setCount(count + 1), 1000)
        }}
      />
      <Text
        align="center"
        type="h1"
        as="span"
        className={cn(styles.title, {
          [styles.title__active]: isActive,
          [styles.title__disabled]: !isAvailable,
        })}
      >
        {title}
        {renderIcon()}
      </Text>
    </div>
  )
}
